<template>
    <div>
        <v-btn
            @click="action == 'create' ? save() : edit()"
            class="buttons buttons--add"
            :disabled="disabled"
            >{{ $t('global:save') }}</v-btn
        >
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    i18nOptions: { namespaces: ['global'] },
    props: {
        action: String,
    },
    data() {
        return {
            disabled: false,
        }
    },

    methods: {
        ...mapActions(['createFolder', 'updateFolder']),
        async save() {
            this.disabled = true
            let success = await this.createFolder({
                routeId: this.$route.params.id,
                routeName: this.$route.name,
            })
            if (success) this.$emit('closeModal')
            this.disabled = false
        },
        async edit() {
            this.disabled = true
            let success = await this.updateFolder({
                routeId: this.$route.params.id,
                routeName: this.$route.name,
            })
            if (success) this.$emit('closeModal')
            this.disabled = false
        },
    },
}
</script>
